/** @jsx jsx **/
import { Flex, jsx } from 'theme-ui'
import { FC } from 'react'
import FilterBadge from '~/components/filter/filter-badge'

type Props = {
  selectedFilters: Array<{ name: string; value: string; label: string; categoryName: string }>
  handleChange: (
    changeItem: {
      name: string
      value: string
    },
    categoryName: string
  ) => void
}

const FilterSelectedItems: FC<Props> = ({ selectedFilters, handleChange }) => {
  if (!selectedFilters.length) return null

  selectedFilters.sort((a, b) => {
    if (typeof a.value === 'boolean') return -1

    if (typeof b.value === 'boolean') return 1
    return 0
  })

  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        gap: '12px',
        mb: ['32px', null, '20px'],
      }}
    >
      {selectedFilters.map((selectedFilter, index) => (
        <FilterBadge
          key={`chip-${index}-${selectedFilter}`}
          onClick={handleChange}
          value={selectedFilter}
        />
      ))}
    </Flex>
  )
}

export default FilterSelectedItems
